export default {"src":"/_next/static/media/sheild.bf2e1aa5.svg","height":52,"width":46};